









import { defineComponent, computed, PropType } from '@vue/composition-api';
import { WarningOutline16 } from '@hb/coffee-icons';

export default defineComponent({
  name: 'OverdueReminder',
  components: {
    WarningOutline16,
  },
  props: {
    overdueDays: {
      type: Number as PropType<number>,
      required: false,
      default: 0,
    },
  },
  setup(props) {
    /** 逾期提醒文案 */
    const overdueText = computed(() => {
      const days = props.overdueDays || 0;

      return `您已逾期${days}天，逾期将产生罚息，请尽快还款`;
    });

    return {
      overdueText,
    };
  },
});
